import type { InjectionKey } from "vue";

interface DropdownMenuProvide {
  close: () => void;
}

export const dropdownKey: InjectionKey<DropdownMenuProvide> = Symbol("dropdownMenu");
